var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"smole-padding",attrs:{"depressed":"","color":"addcolor","disabled":_vm.disabled},on:{"click":_vm.add}},[_c('span',{staticClass:"material-icons smole-size"},[_vm._v("add_circle_outline")]),_vm._v("追加")])}
var staticRenderFns = []

export { render, staticRenderFns }